/* ============================================================================
   VILLAINS TCG — Recently viewed (cst-recently-viewed.js)
   Reads the store-wide localStorage list (cst:rv) and hydrates the carousel with
   real product cards fetched from /products/{handle}?view=card. Reveals the section
   only if at least one card resolves (never shows an empty rail). Quick-add works
   via the delegated handler in cst-product-rail.js loaded alongside on the page.
   Re-runs on shopify:section:load so it hydrates after a Theme Editor re-render.
   ========================================================================== */
(() => {
  const hydrate = (sec) => {
    if (!sec || sec.dataset.cstRvReady) return;
    const row = sec.querySelector('[data-cst-recently-row]');
    if (!row || row.children.length) return;

    let handles = [];
    try { handles = JSON.parse(localStorage.getItem('cst:rv') || '[]'); } catch (_) { handles = []; }
    if (!Array.isArray(handles) || !handles.length) return;
    sec.dataset.cstRvReady = '1';

    const limit = parseInt(sec.dataset.limit || '8', 10) || 8;
    handles = handles.slice(0, limit);

    Promise.all(handles.map((h) =>
      fetch(`/products/${encodeURIComponent(h)}?view=card`, { credentials: 'same-origin' })
        .then((r) => (r.ok ? r.text() : ''))
        .catch(() => '')
    )).then((chunks) => {
      const frag = document.createDocumentFragment();
      chunks.forEach((html) => {
        const t = (html || '').trim();
        if (!t) return;
        const li = document.createElement('li');
        li.innerHTML = t;
        if (li.querySelector('.cst-product-card')) frag.appendChild(li);
      });
      if (frag.childElementCount) {
        row.appendChild(frag);
        sec.removeAttribute('hidden');
      } else {
        // nothing resolved (offline / removed products) → allow a later retry
        delete sec.dataset.cstRvReady;
      }
    });
  };

  const init = (root) => {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-cst-recently]').forEach(hydrate);
    if (root && root.matches && root.matches('[data-cst-recently]')) hydrate(root);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target || document));
})();
